import React from "react";
// css
import "./GreekCard.css";

// Greek Card
const GreekCard = (props) => {
  return (
    <>
      <div className={`greekiland_card ${props.className}`}>
        <div>
          <h2>{props.text}</h2>
        </div>
      </div>
    </>
  );
};

export default GreekCard;
